import { render } from "./ModalFormBrand.vue?vue&type=template&id=49e2dfa6&scoped=true"
import script from "./ModalFormBrand.vue?vue&type=script&lang=js"
export * from "./ModalFormBrand.vue?vue&type=script&lang=js"

import "./ModalFormBrand.vue?vue&type=style&index=0&id=49e2dfa6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49e2dfa6"]])

export default __exports__